/**
 * Anclas de la página de inicio (Optioutlet).
 *
 * El hero manda a la sección de categorías con /#personajes. No se puede
 * poner ese id en el HTML: la sección ya trae el suyo
 * (shopify-section-template--<número>__mundos) y el número cambia entre
 * temas y publicaciones, así que no sirve para enlazar. Los bloques de
 * texto tampoco ayudan: su ajuste es richtext y Shopify le quita el id.
 *
 * De ahí que el enlace se resuelva aquí, enganchando por sufijo igual que
 * lo hace la hoja de estilos.
 */
const ANCLAS = {
  personajes: '[id$="__mundos"]',
  // El botón de la segunda lámina del banner baja al spotlight "No es solo
  // el lente", que es donde corre el video del kit.
  kit: '[id$="__spotlight_combo"]',
};

document.addEventListener('click', (evento) => {
  const enlace = evento.target.closest('a[href*="#"]');
  if (!enlace) return;

  const hash = enlace.hash?.slice(1);
  const selector = ANCLAS[hash];
  if (!selector) return;

  // Solo si el enlace apunta a esta misma página.
  if (enlace.pathname && enlace.pathname !== window.location.pathname) return;

  const destino = document.querySelector(selector);
  if (!destino) return;

  evento.preventDefault();
  // scrollIntoView encuentra solo el contenedor que de verdad desplaza,
  // que arriba de 990px no es el documento sino .page-wrapper.
  destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
  history.replaceState(null, '', `#${hash}`);

  // Que el teclado siga donde quedó la vista.
  const foco = destino.querySelector('a[href], button');
  foco?.focus({ preventScroll: true });
});
